export default {
  env (test) {
    let env = null

    if (location.hostname === 'localhost' || location.hostname.endsWith('devis-b2b.d')) {
      env = 'local'
    } else if (location.hostname.endsWith('staging.devis-b2b.com')) {
      env = 'staging'
    } else {
      env = 'production'
    }

    if(test) {
      return test === env
    } else {
      return env
    }
  },
  eventEndpoint () {
    if(this.env('local')) {
      return 'http://events.devis-b2b.d'
    } else if(this.env('staging')) {
      // TODO
      return 'http://events.staging.devis-b2b.com'
    } else {
      return 'https://events.devis-b2b.com'
    }
  },
  url (endpoint, resource) {
    let protocol = null
    let tld = null

    if(this.env('local')) {
      protocol = 'http'
      tld = 'devis-b2b.d'
    } else if(this.env('staging')) {
      protocol = 'http'
      tld = 'staging.devis-b2b.com'
    } else {
      protocol = 'https'
      tld = 'devis-b2b.com'
    }

    return protocol + '://' + endpoint + '.' + (tld + '/' + resource).replace('//', '/')
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/nexus-js/helpers.js